const breadcrumbsHome = { name: 'Home', pathName: '/home', onlyAvailableOnVue2: true }
const breadcrumbsConfiguracoes = { name: 'Configurações', pathName: null }

export default [
  {
    path: '/v3/configuracoes',
    name: 'Configuracoes',
    component: () => import('@/views/BaseRoutingComponent.vue'),
    children: [
      {
        path: 'redes-sociais',
        name: 'configuracoes-redes-sociais',
        component: () => import('@/modules/configuracoes/redes-sociais/views/pages/RedesSociais.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsConfiguracoes,
            {
              name: 'Links e redes sociais',
              pathName: null,
            },
          ],
          title: 'Links e redes sociais',
          requiredUserPermissions: ['configuracoes/redes-sociais'],
        },
      },
    ],
  },
]
